import {Injectable} from "@angular/core";
import {ServerService} from "../../services/ServerService";
import {HttpClient} from "@angular/common/http";
import {FiltroPedidoUltis} from "../../services/FiltroPedidoUltis";
import {EnumFiltroDePedidos} from "../../services/pedidos.service";
import {IOperacoesModuloPedidos} from "./ioperacoesmodulopedidos";

@Injectable({
  providedIn: 'root'
})
export class GrupolojasService extends  ServerService implements IOperacoesModuloPedidos{
  constructor(http: HttpClient) {
    super(http)
  }

  logado(){
    return this.obtenha('/api/grupolojas/me' , {});
  }

  private paramsCentralPedidos(grupoDeLojasId?: number) {
    return grupoDeLojasId ? { grupoDeLojasId } : {};
  }

  private dadosCentralPedidos(dados: any = {}, grupoDeLojasId?: number) {
    return grupoDeLojasId ? { ...dados, grupoDeLojasId } : dados;
  }

  obtenhaCentralPedidos(grupoDeLojasId?: number){
    return this.obtenha('/grupolojas/central-pedidos/me' , this.paramsCentralPedidos(grupoDeLojasId));
  }

  crieClienteCentralPedidos(dados: any, grupoDeLojasId?: number){
    return this.facaPost('/grupolojas/central-pedidos/clientes', this.dadosCentralPedidos(dados, grupoDeLojasId));
  }

  busqueClientesCentralPedidos(q: string, grupoDeLojasId?: number){
    return this.obtenha('/grupolojas/central-pedidos/clientes' , { q, ...this.paramsCentralPedidos(grupoDeLojasId) });
  }

  selecioneClienteCentralPedidos(empresaId: number, contatoId: number, grupoDeLojasId?: number){
    return this.facaPost(`/grupolojas/central-pedidos/clientes/${empresaId}/${contatoId}/selecionar`, this.dadosCentralPedidos({}, grupoDeLojasId));
  }

  selecioneEnderecoCentralPedidos(empresaId: number, contatoId: number, enderecoId: number, grupoDeLojasId?: number){
    return this.facaPost(`/grupolojas/central-pedidos/clientes/${empresaId}/${contatoId}/enderecos/${enderecoId}/selecionar`, this.dadosCentralPedidos({}, grupoDeLojasId));
  }

  roteieLojaCentralPedidos(empresaId: number, contatoId: number, enderecoId: number, grupoDeLojasId?: number){
    return this.facaPost('/grupolojas/central-pedidos/rotear-loja', this.dadosCentralPedidos({ empresaId, contatoId, enderecoId }, grupoDeLojasId));
  }

  carregueCardapioCentralPedidos(empresaId: number, grupoDeLojasId?: number){
    return this.obtenha(`/grupolojas/central-pedidos/lojas/${empresaId}/cardapio`, this.paramsCentralPedidos(grupoDeLojasId));
  }

  prepareAtendimentoV3CentralPedidos(dados: any, grupoDeLojasId?: number){
    return this.facaPost('/grupolojas/central-pedidos/preparar-atendimento-v3', this.dadosCentralPedidos(dados, grupoDeLojasId));
  }

  prepareLojaV3CentralPedidos(dados: any, grupoDeLojasId?: number){
    return this.facaPost('/grupolojas/central-pedidos/preparar-loja-v3', this.dadosCentralPedidos(dados, grupoDeLojasId));
  }

  listePedidos(inicio: number, total: number, filtro: any = {},
               filtroPedido: EnumFiltroDePedidos = EnumFiltroDePedidos.todos){

    let dados: any = FiltroPedidoUltis.obtenhaDados(inicio, total, filtro, filtroPedido);

    return this.obtenha('/grupolojas/pedidos', dados);
  }

  listePedidosCancelados(inicio: number, total: number, contato: any = null,  dtInicio: string = null, dtFim: string= null,
                         filtro: EnumFiltroDePedidos = EnumFiltroDePedidos.todos, q: string){
    let dados: any = { i: inicio, t: total, cancelados: true};

    if(contato) dados.cid = contato.id;
    if(dtInicio) dados.di = dtInicio;
    if(dtFim) dados.df = dtFim;
    dados.q = q;
    dados.f = filtro;

    return this.obtenha('/grupolojas/pedidos', dados);
  }

  obtenhaPorCodigo(codigo: any, idEmpresa: any) {
    return this.obtenha(String(`/grupolojas/pedidos/${idEmpresa}/${codigo}`), {})
  }

  foiVisualizado(pedido: any, idEmpresa: any){
    return this.salve(String(`/grupolojas/pedidos/visualizado/${idEmpresa}/${pedido.id}`), pedido)
  }

  obtenhaPorGuid(codigo: any,  idEmpresa: any ) {
    return this.obtenha(String(`/grupolojas/pedidos/chave/${idEmpresa}/${codigo}`), {  });
  }


  listeUltimoPedidosAtras(tempo: number, origens = []){
    return this.obtenha('/grupolojas/pedidos/ultimo/' + tempo, { o: origens.join(',')});
  }

  altereEntregador(pedido: any, entregador: any) {
    let params: any = { guid: pedido.guid, entregador: entregador};

    return this.facaPut(`/grupolojas/pedidos/' + pedido.guid + '/entregador/${pedido.empresa.id}/${pedido.id}`, params)
  }


  altereStatus(pedido: any, status: any, notificar: boolean){
    let params: any = { id: pedido.id, status: status};

    if(notificar) params.notificar = true;

    return this.salve(String(`/grupolojas/pedidos/status/${pedido.empresa.id}/${pedido.id}`), params)
  }

  cancelePedido(pedido: any, motivo: any, notificar: boolean){
    let params: any = { guid: pedido.guid, motivo: motivo};

    if(notificar) params.notificar = true;

    return this.facaPut(String(`/grupolojas/pedidos/cancele/${pedido.empresa.id}/${pedido.id}`), params)
  }

  altereFoiPago(pedido: any, foiPago: boolean, formaDePagamento: any){
    return this.salve(String(`/grupolojas/pedidos/pago/${pedido.empresa.id}/${pedido.id}`),
      { id: pedido.id, pago: foiPago, formaDePagamento: formaDePagamento})
  }

  notifiqueSistemaIntegrado(pedido: any){
    return this.facaPost(String(`/grupolojas/pedidos/integracao/notifique/${pedido.empresa.id}/${pedido.id}`), { id: pedido.id});
  }


}
